import { render } from "./InfoBasicasRA.vue?vue&type=template&id=5b3b5684&scoped=true"
import script from "./InfoBasicasRA.vue?vue&type=script&lang=js"
export * from "./InfoBasicasRA.vue?vue&type=script&lang=js"

import "./InfoBasicasRA.vue?vue&type=style&index=0&id=5b3b5684&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3b5684"]])

export default __exports__